import { getMonitoringReport } from "./getMonitoringReport";
import { postMonitoringReport } from "./postMonitoringReport";
import { deleteMonitoringReport } from "./deleteMonitoringReport";

export const monitoringReportApi = {
  getMonitoringReport,
  postMonitoringReport,
  deleteMonitoringReport
};
